import Breadcrumb from "components/shared/breadcrumb";
import SwitchButton from "components/shared/switchButton";
import React, { memo, useContext, useEffect, useId, useState } from "react";
import InitializeContext from "context/initialize-context";
import UseFetch from "hooks/useFetch";
import { toMoneyFormat } from "utils";
import { CSSTransition } from "react-transition-group";
import { toast } from "react-toastify";
import MasterAPI from "service/master";

const SendMethods = () => {
    const enumsData = useContext(InitializeContext);
    const deliveryTypes = enumsData.data.shopSettingDeliveryTypes;

    const id = useId();
    const [sendBySeller, setSendBySeller] = useState(false);
    const [fields, setFields] = useState([]);
    const { isLoading, data, error, mutate } = UseFetch("/api/profile/get");
    const [submitLoading, setSubmitLoading] = useState(false);

    useEffect(() => {
        if (!isLoading && !error) {
            const defaultValuesHolder = data.data.module_fields.delivery.delivery_methods;
            let minPriority = deliveryTypes[0].priority;

            let newDeliveryTypes = [];
            deliveryTypes.forEach(type => {
                if (type.priority < minPriority)
                    newDeliveryTypes = [type, ...newDeliveryTypes];
                else
                    newDeliveryTypes.push(type);
            });

            const newFields = newDeliveryTypes.map(type => {
                const thisDefValue = defaultValuesHolder[type.id] || {};

                return {
                    title: type.title,
                    id: type.id,
                    base_price: thisDefValue.base_price || 0,
                    price_per_kg: thisDefValue.price_per_kg || 0,
                    status_id: thisDefValue.status_id,
                }
            })

            setFields(newFields);
            setSendBySeller(data.data.module_fields.delivery.status_id);
        }

        // eslint-disable-next-line
    }, [isLoading, error, data])

    const changeHandler = (index, fieldName, value) => {
        let localValue = value;

        if (fieldName === "base_price" || fieldName === "price_per_kg") {
            if (value === "")
                localValue = 0;
            else {
                value = value.replaceAll(",", "");

                if (/^[0-9\b]+$/.test(value))
                    localValue = parseInt(value);
                else
                    return;
            }
        }

        setFields(prev => {
            const newState = [...prev];
            newState[index][fieldName] = localValue;

            return newState;
        });
    }

    const submitHandler = async () => {
        if (submitLoading)
            return;

        setSubmitLoading(true);
        const payloadFields = {};
        fields.forEach(type => {
            payloadFields[type.id] = {
                base_price: type.base_price,
                price_per_kg: type.price_per_kg,
                status_id: type.status_id
            }
        })

        try {
            const res = await MasterAPI({
                url: "/api/profile/edit_module_fields",
                method: "PUT",
                payloadType: 3,
                data: {
                    module_fields: {
                        delivery: {
                            status_id: sendBySeller ? 1 : 0,
                            delivery_methods: payloadFields
                        }
                    }
                },
                callback: () => setSubmitLoading(false)
            });

            toast.success(res.message);
        } catch (e) {
            toast.error(e.message);
        }
    }

    return (
        <div className="m-container">
            <div className="flex item-start md:items-center justify-start md:justify-between flex-col md:flex-row mb-10">
                <div className="mb-6 md:mb-0">
                    <h1 className="title-c1 tp-21">گزینه های ارسال</h1>

                    <Breadcrumb data={[
                        { title: "اطلاعات فروشگاه" },
                        { title: "گزینه های ارسال" }
                    ]} />
                </div>

                <div className="flex">
                    <button className="w-10 h-10 tp-22 text-[#424e79] dark:text-white ml-3 rounded-md fit-center" onClick={mutate} title="بروزرسانی">
                        <i className="fa-regular fa-arrows-retweet"></i>
                    </button>

                    <button
                        className={`bg-primary-100 hover:bg-primary-200 px-3 transition-colors text-white rounded-md fit-center text-sm h-10 relative overflow-hidden${submitLoading ? " cursor-progress" : ""}`}
                        onClick={submitHandler}
                    >
                        <i className="fa-light fa-pen-to-square ml-2"></i>
                        ثبت تغییرات

                        <CSSTransition in={submitLoading} timeout={200} unmountOnExit={true}>
                            <span className="pos-cover bg-primary-200 fit-center anim-c4">
                                <i className="fa-solid fa-spinner spin"></i>
                            </span>
                        </CSSTransition>
                    </button>
                </div>
            </div>

            <div className="wrap-box tp-22">
                {
                    !isLoading ? (
                        !error ? (
                            <>
                                <div className="border-b border-gray-200 dark:border-slate-800 pb-4 mb-4">
                                    <span className="tp-32 text-sm font-medium">تنظیمات ارسال (فروشگاه)</span>

                                    <div className="flex mt-2 items-center">
                                        <SwitchButton
                                            id={`${id}_sendBySeller`}
                                            checked={sendBySeller}
                                            changeHandler={() => setSendBySeller(prev => !prev)}
                                        />

                                        <label htmlFor={`${id}_sendBySeller`} className="text-sm tp-32 mr-2 cursor-pointer">ارسال توسط فروشنده</label>
                                    </div>
                                </div>

                                <div className="grid md:grid-cols-12 send-methods gap-4">
                                    <div className="md:col-span-8">
                                        <div className="mb-4">
                                            <b className="tp-32 mb-4 block">پیک فروشنده</b>

                                            <div className="grid grid-cols-2 gap-4">
                                                {
                                                    fields.map((type, i) => (
                                                        <React.Fragment key={`field-${i}`}>
                                                            <div className="col-span-2 flex mt-2 items-center">
                                                                <label className={`switch${type.status_id ? " active" : ""}`}>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={type.status_id === 1}
                                                                        onChange={e => changeHandler(i, "status_id", e.target.checked ? 1 : 0)}
                                                                    />
                                                                </label>

                                                                <label htmlFor={`${id}_sellerDelivery`} className="text-sm tp-32 mr-2 cursor-pointer">
                                                                    {type.title}
                                                                </label>
                                                            </div>

                                                            <div className="field">
                                                                <label className="lbl">هزینه پایه ارسال (تا وزن یک کیلوگرم):</label>
                                                                <input
                                                                    type="text"
                                                                    value={toMoneyFormat(type.base_price)}
                                                                    onChange={e => changeHandler(i, "base_price", e.target.value)}
                                                                />
                                                            </div>

                                                            <div className="field">
                                                                <label className="lbl">هزینه به ازای هر کیلوگرم وزن اضافه:</label>
                                                                <input
                                                                    type="text"
                                                                    value={toMoneyFormat(type.price_per_kg)}
                                                                    onChange={e => changeHandler(i, "price_per_kg", e.target.value)}
                                                                />
                                                            </div>
                                                        </React.Fragment>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className="md:col-span-4 text-sm">
                                        <div className="mb-6">
                                            <span className="tp-32 block mb-2">
                                                <i className="fa-regular fa-circle-info ml-2"></i>
                                                روش ارسال
                                            </span>

                                            <span className="tp-32 block">
                                                وارد کردن مقدار صفر برای هزینه ی ارسال تغییری در کادرمزد ایجاد نمی کند.
                                            </span>
                                        </div>

                                        <div className="mb-6">
                                            <span className="tp-32 block mb-2">
                                                <i className="fa-regular fa-circle-info ml-2"></i>
                                                ارسال پست سفارشی
                                            </span>

                                            <span className="tp-32 block">
                                                باید همراه با پیشتاز انتخاب شود.
                                            </span>
                                        </div>

                                        <div className="mb-6">
                                            <span className="tp-32 block mb-2">
                                                <i className="fa-regular fa-circle-info ml-2"></i>
                                                ارسال با پیک
                                            </span>

                                            <span className="tp-32 block">
                                                فقط برای سفارشات درون شهری است.
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : <></> // error
                    ) : <></> // loading
                }
            </div>
        </div>
    )
}

export default memo(SendMethods);